function Change(props) {

  return (
    <li>
      • {props.change}
    </li>
  )
}

export default Change;
